import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IEHSExamsResults } from '../../Interfaces/IEHSExamsResults';
import { EHSExamsService } from '../../services/ehsExams-services';
import { IQuestions } from '../../Interfaces/IQuestions';

declare var jQuery: any;

@Component({
  selector: 'app-exams-results-detail',
  templateUrl: './exams-results-detail.component.html',
  styles: [
  ]
})
export class ExamsResultsDetailComponent implements OnInit {
  loading = false;
  station: string = 'TABLE';
  listQuestions: Array<IQuestions> = [];
  formGroup: FormGroup;
  columns: Array<any> = [
		'question',
		'answer',
    'result',
	];
	displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);
  constructor(
    private dialogRef: MatDialogRef<ExamsResultsDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEHSExamsResults,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService,
    private EHSExamsService: EHSExamsService
  ) {
    this.formGroup = this.formBuilder.group({
      examName: [data.examname],
      visitorname: [data.visitorname],
      examtries: [data.tries],
      exampointtopass: [data.exampointtopass],
      examtype: [data.examtype],
      visitorid: [data.visitorid],
      ehsssponsorname: [data.ehsssponsorname],
      examcode: [data.examcode],
    });
  }

  ngOnInit(): void {
    jQuery('button-add').hide();
    this.GetAnswersByExamCode();
  }

  GetAnswersByExamCode() {
    this.loading = true;
    this.EHSExamsService.GetAnswersByExamCode(this.formGroup.value).subscribe(
      (result: TransactionResult<IQuestions[]>) => {
        this.loading = false;
        if (result.success) {
          this.listQuestions = result.data;
        }
        else{
          this.ErrorAlert(result.message);
        }
      },
      (error) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
  }

  Close() {
    this.dialogRef.close(true);
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
 	}

}
